import { render, staticRenderFns } from "./ReqAwsContact.vue?vue&type=template&id=4a3ddce4&scoped=true&"
import script from "./ReqAwsContact.vue?vue&type=script&lang=js&"
export * from "./ReqAwsContact.vue?vue&type=script&lang=js&"
import style0 from "./ReqAwsContact.vue?vue&type=style&index=0&id=4a3ddce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3ddce4",
  null
  
)

export default component.exports